import DocumentUploadLabel from './DocumentUploadLabel';

export default DocumentUploadLabel;
